
import { Button } from "@/components/ui/button";
import { cn } from "@/lib/utils";
import { ArrowUpRight, Loader2, Plus } from "lucide-react";

interface ButtonColorfulProps extends React.ButtonHTMLAttributes<HTMLButtonElement> {
    label?: string;
    isLoading?: boolean;
    iconPosition?: "left" | "right";
    icon?: "arrow" | "plus" | "none";
}

export function ButtonColorful({
    className,
    label = "Explore Components",
    isLoading = false,
    disabled,
    iconPosition = "right",
    icon = "arrow",
    ...props
}: ButtonColorfulProps) {
    return (
        <Button
            variant="purple"
            className={cn(
                "min-w-max whitespace-nowrap",
                className
            )}
            disabled={isLoading || disabled}
            {...props}
        >
            {isLoading ? (
                <>
                    <Loader2 className="h-4 w-4 animate-spin text-white mr-1.5" />
                    <span>Loading...</span>
                </>
            ) : (
                <>
                    {iconPosition === "left" && icon === "plus" && (
                        <Plus className="w-3.5 h-3.5 text-white/90 mr-1.5" />
                    )}
                    
                    <span>{label}</span>
                    
                    {iconPosition === "right" && icon === "arrow" && (
                        <ArrowUpRight className="w-3.5 h-3.5 text-white/90 ml-1.5" />
                    )}
                    
                    {iconPosition === "right" && icon === "plus" && (
                        <Plus className="w-3.5 h-3.5 text-white/90 ml-1.5" />
                    )}
                </>
            )}
        </Button>
    );
}
